import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { resolveOAuthRedirectUri } from '../util/oauth-hub.util';

@Component({
    selector: 'app-google-callback',
    template: '<p>Procesando autenticación de Google...</p>',
    standalone: false
})
export class GoogleCallbackComponent implements OnInit {
    /** Origin del tenant que inició el login (viene en el state); se le postea el resultado. */
    private tenantOrigin = '';

    constructor(private route: ActivatedRoute, private http: HttpClient) {}

    ngOnInit() {
        const code = this.route.snapshot.queryParamMap.get('code');
        // state = "<flow>|<tenantOrigin>". Compat: si no trae '|', es el flow pelado.
        const rawState = this.route.snapshot.queryParamMap.get('state') || '';
        const [flow, tenantOrigin] = rawState.split('|');
        this.tenantOrigin = tenantOrigin || window.location.origin;

        if (!code) {
            this.postToOpener({ type: 'GOOGLE_OAUTH_ERROR', error: 'No code received' });
            return;
        }

        // Debe coincidir EXACTO con el redirect_uri enviado a Google.
        // login -> hub central; connect (Drive) -> origin del tenant (mismo origin, tiene el token).
        const redirectUri = flow === 'connect'
            ? window.location.origin + '/google-callback'
            : resolveOAuthRedirectUri('google-callback');

        // state distingue el flujo: 'connect' vincula la cuenta (identidad + Drive)
        // al usuario ya logueado; el resto es el login con Google de siempre.
        if (flow === 'connect') {
            this.connectGoogle(code, redirectUri);
            return;
        }

        this.http.post(`${environment.apiUrl}/common/auth/google-exchange`, { code, redirect_uri: redirectUri })
            .subscribe({
                next: (resp: any) => {
                    const data = resp.result || resp;
                    this.postToOpener({
                        type: 'GOOGLE_OAUTH_SUCCESS',
                        provider_id: data.provider_id,
                        email: data.email,
                        name: data.name
                    });
                },
                error: () => {
                    this.postToOpener({ type: 'GOOGLE_OAUTH_ERROR', error: 'Exchange failed' });
                }
            });
    }

    private connectGoogle(code: string, redirectUri: string) {
        // El endpoint exige sesión; el popup es same-origin, así que comparte el token.
        const headers = new HttpHeaders().set('Token', localStorage.getItem('access_token') || '');

        this.http.post(`${environment.apiUrl}/common/auth/google-connect`,
            { code, redirect_uri: redirectUri }, { headers })
            .subscribe({
                next: (resp: any) => {
                    // La API responde 200 incluso al fallar: el error viaja en resp.error.
                    if (resp?.error) {
                        this.postToOpener({
                            type: 'GOOGLE_OAUTH_ERROR',
                            error: resp.error.message || 'No se pudo conectar la cuenta de Google'
                        });
                        return;
                    }
                    const data = resp.result || resp;
                    this.postToOpener({
                        type: 'GOOGLE_OAUTH_SUCCESS',
                        email: data.email,
                        linked: !!data.linked
                    });
                },
                error: () => {
                    this.postToOpener({
                        type: 'GOOGLE_OAUTH_ERROR',
                        error: 'No se pudo conectar la cuenta de Google'
                    });
                }
            });
    }

    private postToOpener(data: any) {
        if (window.opener) {
            // Postear al origin del tenant que abrió el popup (viene en el state),
            // no al origin del hub donde corre este callback.
            window.opener.postMessage(data, this.tenantOrigin || window.location.origin);
            setTimeout(() => window.close(), 500);
        }
    }
}
